// 共用：在某個 utils/ColGroup.jsx 檔
export function ColGroup({ weights }) {
  const total = weights.reduce((a,b) => a + b, 0);
  return (
    <colgroup>
      {weights.map((w, i) => (
        <col key={i} style={{ width: `${(w/total)*100}%` }} />
      ))}
    </colgroup>
  );
}
